import { useEffect } from 'react';
import { Route, Switch, Redirect, BrowserRouter } from 'react-router-dom';
import { Screen1, Screen2  } from './pages'

function App() {

  const defaultDeadbodyValue:string = 'DB3';
  
  useEffect(() => {
    document.title = "Somatic Clone Viewer (SCV)"
  }, []);

  return (
        <BrowserRouter>
            <Switch>
              <Route exact path="/" >
                  <Redirect to={`/Screen1/${defaultDeadbodyValue}`} />  
              </Route>
              <Route exact path={'/Screen1/:deadbody'} component={Screen1} />
              <Route exact path={'/Screen2/:deadbody'} component={Screen2} />
            </Switch>
        </BrowserRouter>      
  );
  
}

export default App;